import { FC } from 'react'
import * as styles from 'components/features/pfm/DeleteAccountModule/DeleteAccountModule.css'
import ConfirmModalComponent from 'components/features/pfm/ConfirmModal/ConfirmModal'
import Button from 'components/features/pfm/Button/Button'
import { deleteMemberAccountActionCreator } from 'actions/memberActions'
import { useForm } from 'react-hook-form'
import Checkbox from 'components/atoms/inputs/Checkbox'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { memberInfoSelector } from 'selectors/globalSelectors'
import { CC_SUPPORT_PHONE_NUMBER } from 'components/features/creditCard/creditCardStore/constants'

export type DeleteAccountModuleStateProps = {
  modalShown: boolean
}

export type DeleteAccountModuleDispatchProps = {
  showDeleteMemberModal: () => void
  hideModal: () => void
  deleteAccount: typeof deleteMemberAccountActionCreator
}

type DeleteAccountModuleProps = DeleteAccountModuleStateProps & DeleteAccountModuleDispatchProps

const DeleteAccountModule: FC<DeleteAccountModuleProps> = (props) => {
  const { modalShown, showDeleteMemberModal, hideModal, deleteAccount } = props
  const memberInfo = useStoreSelector(memberInfoSelector)
  const { watch, register } = useForm<{ confirm: boolean }>()
  const isConfirmed = watch('confirm')

  const modalContent = !!memberInfo?.has_active_ledger ? (
    <>
      Please pay off your balance and call { CC_SUPPORT_PHONE_NUMBER } to close your Status Card before deleting your account.
      <br />
      <br />
      <NavigationLink to='creditcard'>
        Go to Credit Card page
      </NavigationLink>
    </>
  ) : (
    <>
      Deleting your free Status account is permanent and you will forfeit your rewards. Are you sure you want to delete your account?
      <br />
      <br />
      <label className={ styles.checkbox }>
        <Checkbox name='confirm' register={ register } /> Yes, I forfeit my rewards.
      </label>
    </>
  )

  const confirmModal = modalShown ? (
    <ConfirmModalComponent
      onCancel={ hideModal }
      onConfirm={ deleteAccount }
      confirmButtonText='Delete'
      confirmButtonDisabled={ !isConfirmed }
    >
      { modalContent}
    </ConfirmModalComponent>
  ) : null

  const button = (
    <Button style='hollow' onClick={ showDeleteMemberModal } qaMarker='delete-status-account'>
      Delete Status Account
    </Button>
  )

  return (
    <div className={ styles.deleteAccountModule }>
      { confirmModal }
      <div className={ styles.buttonWrapper }>
        { button }
      </div>
    </div>
  )
}

export default DeleteAccountModule
